
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-purple-900">
      <Navbar />
      
      <div className="pt-24 pb-16 px-4">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-black text-white mb-4">
              Terms & Conditions
            </h1>
            <p className="text-gray-400 text-lg">
              Last Updated: January 2025
            </p>
          </div>

          {/* Content */}
          <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-8 md:p-12 space-y-8">
            
            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <i className="ri-file-text-line text-cyan-400"></i>
                1. Acceptance of Terms
              </h2>
              <p className="text-gray-300 leading-relaxed">
                By accessing and using PepCoin platform, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to these terms, please do not use our services.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <i className="ri-user-line text-cyan-400"></i>
                2. User Eligibility
              </h2>
              <p className="text-gray-300 leading-relaxed mb-3">
                To use PepCoin services, you must:
              </p>
              <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
                <li>Be at least 18 years of age</li>
                <li>Have the legal capacity to enter into binding contracts</li>
                <li>Not be prohibited from using our services under applicable laws</li>
                <li>Complete identity verification (KYC) when required</li>
                <li>Provide accurate and complete registration information</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <i className="ri-shield-check-line text-cyan-400"></i>
                3. Account Security
              </h2>
              <p className="text-gray-300 leading-relaxed mb-3">
                You are responsible for:
              </p>
              <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
                <li>Maintaining the confidentiality of your account credentials</li>
                <li>All activities that occur under your account</li>
                <li>Notifying us immediately of any unauthorized access</li>
                <li>Using strong passwords and enabling two-factor authentication</li>
                <li>Not sharing your account with others</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <i className="ri-exchange-line text-cyan-400"></i>
                4. Trading Services
              </h2>
              <p className="text-gray-300 leading-relaxed mb-3">
                Our trading platform provides:
              </p>
              <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
                <li>Cryptocurrency trading services (spot trading, P2P)</li>
                <li>AI-powered trading assistance and optimization</li>
                <li>Real-time market data and analytics</li>
                <li>Wallet services for digital asset storage</li>
              </ul>
              <p className="text-gray-300 leading-relaxed mt-3">
                All trades are final and cannot be reversed. You acknowledge that cryptocurrency trading involves substantial risk of loss.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <i className="ri-cpu-line text-cyan-400"></i>
                5. Mining Services
              </h2>
              <p className="text-gray-300 leading-relaxed">
                Our mining services are provided "as is" without guarantees of specific returns. Mining rewards depend on network difficulty, hashrate, and other factors beyond our control. We reserve the right to modify mining plans and reward structures with notice.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <i className="ri-money-dollar-circle-line text-cyan-400"></i>
                6. Fees and Payments
              </h2>
              <p className="text-gray-300 leading-relaxed mb-3">
                PepCoin charges fees for various services:
              </p>
              <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
                <li>Trading fees (displayed before transaction confirmation)</li>
                <li>Withdrawal fees (network-dependent)</li>
                <li>Mining service fees (included in plan pricing)</li>
                <li>P2P transaction fees</li>
              </ul>
              <p className="text-gray-300 leading-relaxed mt-3">
                All fees are clearly disclosed before you complete any transaction. We reserve the right to modify fees with 30 days notice.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <i className="ri-forbid-line text-cyan-400"></i>
                7. Prohibited Activities
              </h2>
              <p className="text-gray-300 leading-relaxed mb-3">
                You agree not to:
              </p>
              <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
                <li>Use our services for illegal activities or money laundering</li>
                <li>Manipulate markets or engage in fraudulent trading</li>
                <li>Attempt to gain unauthorized access to our systems</li>
                <li>Use bots or automated systems without authorization</li>
                <li>Violate any applicable laws or regulations</li>
                <li>Create multiple accounts to abuse promotions</li>
                <li>Engage in wash trading or market manipulation</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <i className="ri-alert-line text-cyan-400"></i>
                8. Risk Disclosure
              </h2>
              <div className="bg-red-500/10 border border-red-500/30 rounded-lg p-6">
                <p className="text-red-300 leading-relaxed mb-3">
                  <strong>WARNING:</strong> Cryptocurrency trading carries substantial risk of loss. You should:
                </p>
                <ul className="list-disc list-inside text-red-300 space-y-2 ml-4">
                  <li>Only invest what you can afford to lose</li>
                  <li>Understand that past performance doesn't guarantee future results</li>
                  <li>Be aware of extreme price volatility</li>
                  <li>Conduct your own research before trading</li>
                  <li>Seek professional financial advice if needed</li>
                </ul>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <i className="ri-file-shield-line text-cyan-400"></i>
                9. Intellectual Property
              </h2>
              <p className="text-gray-300 leading-relaxed">
                All content, trademarks, logos, and intellectual property on PepCoin platform are owned by us or our licensors. You may not use, copy, or distribute any content without our written permission.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <i className="ri-close-circle-line text-cyan-400"></i>
                10. Account Termination
              </h2>
              <p className="text-gray-300 leading-relaxed">
                We reserve the right to suspend or terminate your account at any time for violation of these terms, suspicious activity, or legal requirements. Upon termination, you may withdraw your funds subject to applicable fees and verification requirements.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <i className="ri-mail-line text-cyan-400"></i>
                11. Contact Information
              </h2>
              <p className="text-gray-300 leading-relaxed">
                For questions about these terms, please contact us at:
              </p>
              <div className="mt-4 space-y-2">
                <p className="text-cyan-400">Email: legal@pepcoin.com</p>
                <p className="text-cyan-400">Support: support@pepcoin.com</p>
                <Link to="/contact" className="text-cyan-400 hover:text-cyan-300 inline-flex items-center gap-2 cursor-pointer">
                  Contact Form <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </section>

          </div>

          {/* Footer Actions */}
          <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/privacy"
              className="px-6 py-3 bg-white/10 border border-white/20 rounded-lg text-white font-medium hover:bg-white/20 transition-all duration-300 text-center cursor-pointer whitespace-nowrap"
            >
              <i className="ri-shield-user-line mr-2"></i>
              Privacy Policy
            </Link>
            <Link
              to="/risk-disclosure"
              className="px-6 py-3 bg-white/10 border border-white/20 rounded-lg text-white font-medium hover:bg-white/20 transition-all duration-300 text-center cursor-pointer whitespace-nowrap"
            >
              <i className="ri-alert-line mr-2"></i>
              Risk Disclosure
            </Link>
            <Link
              to="/"
              className="px-6 py-3 bg-gradient-to-r from-cyan-500 to-purple-600 rounded-lg text-white font-medium hover:scale-105 transition-all duration-300 text-center cursor-pointer whitespace-nowrap"
            >
              <i className="ri-home-line mr-2"></i>
              Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
